document.addEventListener("DOMContentLoaded", function () {
  /* =========================================
     EXTERNAL LINK WARNING
  ========================================= */
  const currentHost = window.location.hostname.replace("www.", "");
  const warningText =
    " Redirecting to a third-party website (opens in a new tab).";

  document
    .querySelectorAll('a[href^="http://"], a[href^="https://"]')
    .forEach(function (link) {
      const linkHost = link.hostname.replace("www.", "");

      // Skip internal links
      if (linkHost === currentHost || !linkHost) return;

      let linkText = link.textContent.trim();

      // Use image alt text if link has no text
      if (!linkText) {
        const img = link.querySelector("img");
        const imgAlt = img ? img.getAttribute("alt") : "";
        linkText = imgAlt ? imgAlt.trim() : "this link";
      }

      const currentAriaLabel = link.getAttribute("aria-label") || "";

      if (!currentAriaLabel.includes(warningText.trim())) {
        const newLabel = currentAriaLabel
          ? `${currentAriaLabel}${warningText}`
          : `${linkText}${warningText}`;

        link.setAttribute("aria-label", newLabel);
        link.setAttribute("title", newLabel);
      }

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer nofollow");
      link.classList.add("external-link");
    });

  /* =========================================
     EMAIL LINKS
  ========================================= */
  document.querySelectorAll('a[href^="mailto:"]').forEach(function (link) {
    if (!link.getAttribute("aria-label")) {
      const emailText = link.textContent.trim();

      if (emailText) {
        link.setAttribute("aria-label", "Email address " + emailText);
      }
    }
  });

  /* =========================================
     PHONE LINKS
  ========================================= */
  document.querySelectorAll('a[href^="tel:"]').forEach(function (link) {
    if (!link.getAttribute("aria-label")) {
      const phoneText = link.textContent.trim();

      if (phoneText) {
        link.setAttribute("aria-label", "Phone number " + phoneText);
      }
    }
  });

  /* =========================================
     HORIZONTAL RULE / LINE BREAK
  ========================================= */
  document.querySelectorAll("br").forEach(function (br) {
    br.setAttribute("aria-hidden", "true");
  });

  document.querySelectorAll("hr").forEach(function (hr) {
    hr.setAttribute("aria-hidden", "true");
  });

  /* =========================================
     HERO LIST ITEMS
  ========================================= */
  document
    .querySelectorAll(".Hero_side_innerlist_mainboxs_new")
    .forEach(function (element) {
      element.setAttribute("role", "listitem");
      element.removeAttribute("aria-label");
    });

  document
    .querySelectorAll(".Hero_side_innerloop_mainboxs_new")
    .forEach(function (element) {
      element.removeAttribute("aria-label");
    });

  /* =========================================
     DESKTOP ONLY ELEMENTS
  ========================================= */
  document.querySelectorAll(".Desktop_only_new").forEach(function (element) {
    element.removeAttribute("role");
    element.removeAttribute("aria-label");
  });

  /* =========================================
     SWIPER ACCESSIBILITY
  ========================================= */
  document.querySelectorAll(".swiper-wrapper").forEach(function (wrapper) {
    wrapper.removeAttribute("aria-live");
  });

  /* =========================================
     TAB ACCESSIBILITY
  ========================================= */
  document.querySelectorAll(".tablinks").forEach(function (tab) {
    tab.removeAttribute("aria-label");
    tab.setAttribute("role", "tab");

    // role=tab must be owned by a role=tablist parent
    const tabParent = tab.parentElement;
    if (tabParent && !tabParent.getAttribute("role")) {
      tabParent.setAttribute("role", "tablist");
    }

    // Every tab is reachable with the Tab key.
    // The tab scripts mark the selected tab with the "active" class.
    tab.setAttribute("tabindex", "0");
    tab.setAttribute(
      "aria-selected",
      tab.classList.contains("active") ||
        tab.getAttribute("aria-selected") === "true"
        ? "true"
        : "false"
    );
  });

  // Link each tab to its panel(s): role=tab needs a matching role=tabpanel
  // (panels are the ".{tab_id}_open" elements toggled by the tab scripts)
  function uniqueId(base) {
    let id = base;
    let n = 1;
    while (document.getElementById(id)) id = base + "_" + n++;
    return id;
  }

  document.querySelectorAll(".tablinks[tab_id]").forEach(function (tab) {
    const tabId = tab.getAttribute("tab_id");
    const scope = tab.closest(".shopify-section") || document;
    const panels = scope.querySelectorAll("." + tabId + "_open");
    if (!panels.length) return;

    if (!tab.id) tab.id = uniqueId(tabId + "_tab");

    const panelIds = [];
    panels.forEach(function (panel) {
      // reuse an existing tabpanel inside the panel instead of nesting a second one
      const target = panel.querySelector('[role="tabpanel"]') || panel;
      if (!target.id) target.id = uniqueId(tabId + "_panel");
      target.setAttribute("role", "tabpanel");
      target.setAttribute("aria-labelledby", tab.id);
      panelIds.push(target.id);
    });

    tab.setAttribute("aria-controls", panelIds.join(" "));
  });

  // Tab selection
  document.querySelectorAll(".tablinks.active").forEach(function (tab) {
    tab.setAttribute("aria-selected", "true");
  });

  // Screen readers announce the selected tab's name when it changes
  const tabAnnouncer = document.createElement("div");
  tabAnnouncer.className = "visually-hidden";
  tabAnnouncer.setAttribute("aria-live", "polite");
  tabAnnouncer.setAttribute("aria-atomic", "true");
  document.body.appendChild(tabAnnouncer);

  document.addEventListener("click", function (e) {
    const tab = e.target.closest(".tablinks");

    if (!tab) return;

    const parent = tab.parentElement;

    if (!parent) return;

    const tabs = parent.querySelectorAll(".tablinks");

    tabs.forEach(function (currentTab) {
      currentTab.setAttribute("aria-selected", "false");
    });

    tab.setAttribute("aria-selected", "true");

    // Clear first so selecting the same tab again is still announced
    tabAnnouncer.textContent = "";
    setTimeout(function () {
      tabAnnouncer.textContent = tab.textContent.trim() + " selected";
    }, 100);
  });

  // Keyboard: Arrow keys / Home / End move between tabs, Enter / Space select
  document.addEventListener("keydown", function (e) {
    const tab = e.target.closest(".tablinks");

    if (!tab || !tab.parentElement) return;

    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      tab.click();
      return;
    }

    const tabs = Array.from(tab.parentElement.querySelectorAll(".tablinks"));
    const index = tabs.indexOf(tab);
    let next = null;

    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
      next = tabs[(index + 1) % tabs.length];
    } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
      next = tabs[(index - 1 + tabs.length) % tabs.length];
    } else if (e.key === "Home") {
      next = tabs[0];
    } else if (e.key === "End") {
      next = tabs[tabs.length - 1];
    }

    if (!next) return;

    e.preventDefault();
    next.focus();
  });



  /* =========================================
     EXTENDWRAPPER
  ========================================= */
  document.querySelectorAll(".extendwrapper").forEach(function (element) {
    element.removeAttribute("aria-label");
    element.setAttribute("role", "tablist");
  });
  document
    .querySelectorAll(".Product_grid_item_new")
    .forEach(function (element) {
      element.removeAttribute("aria-label");
      element.removeAttribute("role");
    });

  /* =========================================
     CLICKABLE TESTIMONIAL SLIDER
  
  ========================================= */
  document
    .querySelectorAll(".Index_object_testimonials_slider")
    .forEach(function (slider) {
      if (slider.classList.contains("swiper-initialized")) return;

      const wrapper = slider.querySelector(".swiper-wrapper");
      if (!wrapper) return;

      const prevButton = slider.querySelector(".swiper-button-prev");
      const nextButton = slider.querySelector(".swiper-button-next");
      const playPauseButton = slider.querySelector(".swiper-play-pause");

      const SPEED_PX_PER_SEC = 110; // higher = faster
      const NAV_DURATION = 400; // ms for prev/next buttons

      // Announcer element for screen readers
      const announcer = document.createElement("div");
      announcer.setAttribute("aria-live", "polite");
      announcer.setAttribute("aria-atomic", "true");
      announcer.style.cssText =
        "position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;";
      slider.appendChild(announcer);

      /*
       * Clone slides for seamless wrap (clones hidden from assistive tech)
       */
      const originals = Array.from(wrapper.children);
      const originalCount = originals.length;
      if (!originalCount) return;

      /*
       * Videos: load a bit BEFORE a card scrolls in (loading at the moment it
       * appears causes a hitch) and pause videos that are far off-screen so
       * the browser isn't decoding every video at once.
       */
      const sliderVideoObserver =
        "IntersectionObserver" in window
          ? new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  const video = entry.target;
                  if (entry.isIntersecting) {
                    if (!video.dataset.loaded && video.dataset.src) {
                      video.src = video.dataset.src;
                      video.preload = "auto";
                      video.load();
                      video.dataset.loaded = "true";
                    }
                    if (video.paused) video.play().catch(function () {});
                  } else if (!video.paused) {
                    video.pause();
                  }
                });
              },
              { root: slider, rootMargin: "0px 700px" },
            )
          : null;

      function appendClones() {
        originals.forEach(function (slide) {
          const clone = slide.cloneNode(true);
          clone.setAttribute("aria-hidden", "true");
          clone.setAttribute("inert", "");
          clone.removeAttribute("id");
          clone.querySelectorAll("[id]").forEach(function (el) {
            el.removeAttribute("id");
          });
          clone.querySelectorAll("a, button").forEach(function (el) {
            el.setAttribute("tabindex", "-1");
          });
          clone.querySelectorAll("video").forEach(function (video) {
            video.removeAttribute("src");
            delete video.dataset.loaded;
            video.muted = true;
            if (sliderVideoObserver) sliderVideoObserver.observe(video);
          });
          wrapper.appendChild(clone);
        });
      }
      appendClones();

      if (sliderVideoObserver) {
        originals.forEach(function (slide) {
          slide.querySelectorAll("video").forEach(function (video) {
            sliderVideoObserver.observe(video);
          });
        });
      }

      let isPlaying = !window.matchMedia("(prefers-reduced-motion: reduce)")
        .matches;
      let isDragging = false;
      let hasFocusInside = false;
      let isNavigating = false;
      let setWidth = 0;
      let anim = null; // Web Animation running on the compositor thread

      const swiper = new Swiper(slider, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: false,
        freeMode: {
          enabled: true,
          momentum: false,
        },
        watchOverflow: false,
        observer: false,
        grabCursor: true,
        on: {
          init: function () {
            this.slides.forEach(function (slide) {
              slide.removeAttribute("aria-label");
              slide.removeAttribute("aria-live");
            });
          },
          touchStart: function () {
            isDragging = true;
            stopAnim();
          },
          touchEnd: function () {
            if (!isDragging) return;
            isDragging = false;
            startAnim(swiper.getTranslate());
          },
          resize: function () {
            const t = currentOffset();
            measure();
            startAnim(t);
          },
        },
      });

      /*
       * Width of one full set of original slides (incl. gaps)
       */
      function measure() {
        const grid = swiper.slidesGrid;
        setWidth =
          grid && grid.length > originalCount
            ? grid[originalCount] - grid[0]
            : 0;

        // Make sure there is always enough content to fill the viewport
        if (
          setWidth > 0 &&
          wrapper.children.length * (setWidth / originalCount) <
            setWidth + slider.clientWidth
        ) {
          appendClones();
          swiper.update();
          measure();
        }
      }

      function normalize(t) {
        if (!setWidth) return t;
        while (t <= -setWidth) t += setWidth;
        while (t > 0) t -= setWidth;
        return t;
      }

      function duration() {
        return (setWidth / SPEED_PX_PER_SEC) * 1000;
      }

      /* Current visual offset (px, <= 0), whether animating or not */
      function currentOffset() {
        if (anim && setWidth) {
          const time = anim.currentTime || 0;
          return normalize(-((time % duration()) / duration()) * setWidth);
        }
        return normalize(swiper.getTranslate());
      }

      function shouldRun() {
        return isPlaying && !hasFocusInside && !isDragging && !isNavigating;
      }

 
      function stopAnim() {
        if (!anim) return;
        const t = currentOffset();
        anim.cancel();
        anim = null;
        swiper.setTransition(0);
        swiper.setTranslate(t);
      }


      function startAnim(t) {
        if (anim) {
          anim.cancel();
          anim = null;
        }
        if (!setWidth || !wrapper.animate) return;

        t = normalize(t);
        swiper.setTransition(0);
        swiper.setTranslate(t);

        anim = wrapper.animate(
          [
            { transform: "translate3d(0px, 0, 0)" },
            { transform: "translate3d(" + -setWidth + "px, 0, 0)" },
          ],
          { duration: duration(), iterations: Infinity, easing: "linear" },
        );
        anim.currentTime = (-t / setWidth) * duration();
        syncAnim();
      }

      function syncAnim() {
        if (!anim) return;
        if (shouldRun()) {
          if (anim.playState !== "running") anim.play();
        } else if (anim.playState === "running") {
          anim.pause();
        }
      }

      swiper.setTransition(0);
      measure();
      startAnim(0);


      slider.addEventListener("focusin", function (e) {
        const target = e.target;
        if (
          target === playPauseButton ||
          target === prevButton ||
          target === nextButton
        ) {
          hasFocusInside = false;
        } else {
          let isKeyboardFocus = true;
          try {
            isKeyboardFocus = target.matches(":focus-visible");
          } catch (err) {}
          hasFocusInside = isKeyboardFocus;
        }
        syncAnim();
      });
      slider.addEventListener("focusout", function (e) {
        if (!slider.contains(e.relatedTarget)) {
          hasFocusInside = false;
          syncAnim();
        }
      });

      function updatePlayButton() {
        if (!playPauseButton) return;
        playPauseButton.classList.toggle("is-paused", !isPlaying);
        playPauseButton.setAttribute(
          "aria-label",
          isPlaying ? "Pause slider" : "Play slider",
        );
      }
      updatePlayButton();

      /*
       * Play / Pause
       */
      if (playPauseButton) {
        playPauseButton.addEventListener("click", function () {
          isPlaying = !isPlaying;
          updatePlayButton();
          syncAnim();
          announcer.textContent = isPlaying
            ? "Slider playing"
            : "Slider paused";
        });
      }

      /*
       * Prev / Next: glide to the neighbouring card, then resume the loop
       */
      function navigate(direction) {
        const step = setWidth / originalCount;
        if (!step || isDragging) return;

        let from = currentOffset();
        const index =
          direction > 0
            ? Math.floor(-from / step + 0.01) + 1
            : Math.ceil(-from / step - 0.01) - 1;
        let to = -index * step;
  
        if (to > 0) {
          from -= setWidth;
          to -= setWidth;
        }

        if (anim) {
          anim.cancel();
          anim = null;
        }
        isNavigating = true;

        const glide = wrapper.animate(
          [
            { transform: "translate3d(" + from + "px, 0, 0)" },
            { transform: "translate3d(" + to + "px, 0, 0)" },
          ],
          { duration: NAV_DURATION, easing: "cubic-bezier(0.22, 1, 0.36, 1)" },
        );
        swiper.setTranslate(to);
        glide.onfinish = function () {
          isNavigating = false;
          startAnim(to);
        };

        const current = ((index % originalCount) + originalCount) % originalCount;
        announcer.textContent =
          "Showing testimonial " + (current + 1) + " of " + originalCount;
      }

      if (nextButton) {
        nextButton.addEventListener("click", function () {
          navigate(1);
        });
      }

      if (prevButton) {
        prevButton.addEventListener("click", function () {
          navigate(-1);
        });
      }
    });
  /* =========================================
     MEGA NAVIGATION
  ========================================= */
  document.querySelectorAll(".js-mega-nav").forEach(function (menu) {
    const summary = menu.querySelector("summary");
    const submenu = menu.querySelector(".main-nav__child");

    if (!summary || !submenu) return;

    function openMenu() {
      menu.setAttribute("open", "");
      summary.setAttribute("aria-expanded", "true");
    }

    function closeMenu() {
      menu.removeAttribute("open");
      summary.setAttribute("aria-expanded", "false");
      summary.focus();
    }

    // Click
    summary.addEventListener("click", function (e) {
      e.preventDefault();

      const isOpen = menu.hasAttribute("open");

      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    // Keyboard
    summary.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();

        const isOpen = menu.hasAttribute("open");

        if (isOpen) {
          closeMenu();
        } else {
          openMenu();
        }
      }

      if (e.key === "Escape") {
        e.preventDefault();

        if (menu.hasAttribute("open")) {
          closeMenu();
        }
      }
    });

    // Escape inside submenu
    submenu.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        e.preventDefault();
        closeMenu();
      }
    });
  });

  /* =========================================
     BUNDLE BUILDER DIALOG - OPEN
  ========================================= */
  document
    .querySelectorAll(".bundle-builder__card-info")
    .forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        const closeBtn = document.querySelector(
          ".bundle_builder_pdp_innerpopup_innerside_close_new",
        );

        if (closeBtn) {
          closeBtn.setAttribute("tabindex", "-1");
          closeBtn.focus();
        }
      });
    });

  /* =========================================
     BUNDLE BUILDER DIALOG - CLOSE
  ========================================= */
  document
    .querySelectorAll(".bundle_builder_pdp_innerpopup_innerside_close_new")
    .forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        const popup = document.getElementById("bundle_builder_pdp_popup");

        if (popup) {
          popup.setAttribute("tabindex", "-1");
          popup.focus();
        }
      });
    });

  /* =========================================
     INSTAGRAM SWIPER
  ========================================= */
  document.querySelectorAll(".insta-swiper").forEach(function (element) {
    element.setAttribute("role", "list");
  });
  (function () {
    function fixMoreItem() {
      document
        .querySelectorAll('li.menu-list__list-item[slot="more"]')
        .forEach(function (item) {
          if (item.getAttribute("role") !== "presentation") {
            item.setAttribute("role", "presentation");
          }
        });
    }

    fixMoreItem();

    new MutationObserver(function () {
      fixMoreItem();
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["role"],
    });
  })();

  document
    .querySelectorAll(".Instagram_innerloop_mainblock_new")
    .forEach(function (element) {
      element.setAttribute("role", "listitem");
      element.removeAttribute("aria-label");
    });

  /* =========================================
   ACCORDION
 ========================================= */
  document.addEventListener("click", function (e) {
    const button = e.target.closest(".question");

    if (!button) return;

    const isExpanded = button.getAttribute("aria-expanded") === "true";

    button.setAttribute("aria-expanded", String(!isExpanded));
  });

  document.addEventListener("click", function (e) {
    var button = e.target.closest(".faq-contents_item");
    if (!button) return;

    var accordion = button.closest(".faq-accordion");
    if (!accordion) return;

    var body = accordion.querySelector(".faq-contents_body");
    var icon = accordion.querySelector(".faq-contents_icon");

    if (!body) return;

    var expanded = button.getAttribute("aria-expanded") === "true";

    button.setAttribute("aria-expanded", expanded ? "false" : "true");
    button.classList.toggle("is-open", !expanded);

    body.classList.toggle("is-open", !expanded);

    if (icon) {
      icon.classList.toggle("is-open", !expanded);
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".question").forEach(function (button) {
    button.addEventListener("click", function () {
      var isExpanded = this.getAttribute("aria-expanded") === "true";

      this.setAttribute("aria-expanded", isExpanded ? "false" : "true");
    });
  });
});

// this is for gif play pause button function////

document
  .querySelectorAll(".Collection_video_toggle_new")
  .forEach(function (button) {
    const container = button.closest(".Collection_innermedia_new");
    const video = container ? container.querySelector("video") : null;

    if (!video) return;

    // Force video to start paused
    video.removeAttribute("autoplay");
    video.pause();

    function updateButton() {
      const isPaused = video.paused;

      button.classList.toggle("is-paused", isPaused);
      button.setAttribute(
        "aria-label",
        isPaused ? "Play video" : "Pause video",
      );

      const hiddenText = button.querySelector(".visually-hidden");

      if (hiddenText) {
        hiddenText.textContent = isPaused ? "Play video" : "Pause video";
      }
    }
    button.addEventListener("click", function () {
      if (video.paused) {
        if (!video.src && video.dataset.src) {
          video.src = video.dataset.src;
          video.load();
        }
        video.play();
      } else {
        video.pause();
      }
      updateButton();
    });

    video.addEventListener("play", updateButton);
    video.addEventListener("pause", updateButton);

    updateButton();
  });


document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll("[data-label-one][data-label-other]")
    .forEach(function (trigger) {
      const countEl = trigger.querySelector('[ref="cartBubbleCount"]');
      if (!countEl) return;

      const sync = function () {
        const text = (countEl.textContent || "").trim();
        // Bubble is empty at 100+ items: keep the current label
        if (!/^\d+$/.test(text)) return;

        const count = parseInt(text, 10);
        const label =
          count === 1
            ? trigger.dataset.labelOne
            : trigger.dataset.labelOther.replace(/\d+/, String(count));

        if (trigger.getAttribute("aria-label") !== label) {
          trigger.setAttribute("aria-label", label);
        }
      };

      sync();
      new MutationObserver(sync).observe(countEl, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    });
});

(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 989px)';
  var mq = window.matchMedia(MOBILE_QUERY);

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), ' +
    'textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  function init() {
    var details = document.getElementById('Details-menu-drawer-container');
    if (!details || details.dataset.a11yMobileMenu) return;
    details.dataset.a11yMobileMenu = 'true';

    // Query live each time: the theme can re-render the drawer's contents.
    function getSummary() { return details.querySelector(':scope > summary'); }
    function getCloseBtn() { return details.querySelector('.menu-drawer__close-button'); }
    function getDrawer() { return details.querySelector('[ref="menuDrawer"], .menu-drawer'); }
    if (!getSummary() || !getDrawer()) return;

    var inertedEls = [];
    var isActive = false;

    function isMobile() {
      return mq.matches;
    }

    function isVisible(el) {
      if (!el) return false;
      var cs = window.getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && el.getClientRects().length > 0;
    }

    function getFocusable() {
      return Array.prototype.filter.call(details.querySelectorAll(FOCUSABLE), function (el) {
        return isVisible(el) && !el.closest('[inert]');
      });
    }

    /* --- Labels & decorative images (re-applied on every open) --- */
    function applyStaticFixes() {
      var summary = getSummary();
      var closeBtn = getCloseBtn();
      var drawer = getDrawer();
      if (closeBtn) closeBtn.setAttribute('aria-label', 'Close menu');
      if (drawer) {
        if (!drawer.id) drawer.id = 'MobileMenuDrawer';
        if (summary) summary.setAttribute('aria-controls', drawer.id);
        // Card links already have visible text; make their images decorative.
        drawer.querySelectorAll('a img').forEach(function (img) {
          var link = img.closest('a');
          if (link && link.textContent.trim().length) img.setAttribute('alt', '');
        });
      }
    }

    /* --- Background inert handling --- */
    function setBackgroundInert() {
      var node = details;
      while (node && node !== document.body) {
        var parent = node.parentElement;
        if (!parent) break;
        Array.prototype.forEach.call(parent.children, function (sibling) {
          if (sibling === node) return;
          if (/^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(sibling.tagName)) return;
          if (sibling.inert || sibling.hasAttribute('aria-hidden')) return;
          sibling.inert = true;
          sibling.setAttribute('aria-hidden', 'true'); // fallback for older Safari
          inertedEls.push(sibling);
        });
        node = parent;
      }
    }

    function clearBackgroundInert() {
      inertedEls.forEach(function (el) {
        el.inert = false;
        el.removeAttribute('aria-hidden');
      });
      inertedEls = [];
    }

    /* --- Open / close --- */
    function activate() {
      if (isActive || !isMobile()) return;
      isActive = true;

      applyStaticFixes();
      // No role="dialog"/aria-modal here: the theme's Close button sits outside the
      // drawer <div>, and aria-modal would hide it from VoiceOver. Making the rest of
      // the page inert gives the same "only the menu is reachable" result.
      setBackgroundInert();

      // Summary is hidden while open, so move focus into the dialog.
      setTimeout(function () {
        if (!details.open) return;
        var closeBtn = getCloseBtn();
        var target = isVisible(closeBtn) ? closeBtn : getFocusable()[0];
        if (target) target.focus();
      }, 60);
    }

    function deactivate(returnFocus) {
      if (!isActive) return;
      isActive = false;

      clearBackgroundInert();

      if (returnFocus) {
        // Wait for the theme to show the summary again before focusing it.
        setTimeout(function () {
          var active = document.activeElement;
          if (!active || active === document.body || details.contains(active)) {
            var summary = getSummary();
            if (summary) summary.focus();
          }
        }, 60);
      }
    }

    details.addEventListener('toggle', function () {
      if (details.open) activate();
      else deactivate(true);
    });

    /* --- Keyboard: focus trap + Escape --- */
    document.addEventListener('keydown', function (e) {
      if (!isActive || !details.open) return;

      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        var closeBtn = getCloseBtn();
        if (closeBtn) closeBtn.click();
        else details.removeAttribute('open');
        return;
      }

      if (e.key !== 'Tab') return;
      var items = getFocusable();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;

      if (!details.contains(active)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    });

    /* --- Leaving mobile width while open: clean up --- */
    function onMediaChange() {
      if (!isMobile()) deactivate(false);
      else if (details.open) activate();
    }
    if (mq.addEventListener) mq.addEventListener('change', onMediaChange);
    else if (mq.addListener) mq.addListener(onMediaChange);

    if (details.open) activate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();